export default {
  ak_bure:
    "Привет! По результатам теста тебе подходит направление — Ак Буре! \n" +
    "\n" +
    "Ак Буре — это направление Белых Волков, направление тех — кто действует прямо сейчас!\n" +
    "Рискуй, пробуй, кайфуй от процесса — а наша команда всегда будет рядом и поддержит! \n" +
    "\n" +
    'Время действовать, залетай к нам в канал: <a href="https://t.me/akburelf" target="_blank">https://t.me/akburelf</a> \n' +
    "\n" +
    "И главное:\n" +
    "Ак Буре раз — и навсегда!\n" +
    "\n" +
    "\n",
  ak_bars:
    "Йоу! Добро пожаловать в семью!\n" +
    "\n" +
    "По результатам твоего теста тебе идеально подходит направление Белых барсов. \n" +
    "\n" +
    "Ак барс — это направление стильных, драйвовых, ведь для нас самосовершенствование не просто цель, а образ жизни.\n" +
    "\n" +
    'Скорее подписывайся на наш телеграм-канал, говорят там стильно: <a href="https://t.me/akbars_ligaforum" target="_blank">https://t.me/akbars_ligaforum</a>',

  zilant:
    "Привет! Судя по тесту, теперь твои дни будут с оттенком зелёного, ведь ты Зилантовец!\n" +
    "\n" +
    "Если ты в Зиланте, то помни, кем ты являешься, и следуй зову сердца: оно привело тебя к нам на форум Лига форум, так что ты действуешь правильно.\n" +
    "Смелее заходи в наш телеграм-канал и следи за новостями!\n" +
    "\n" +
    '<a href="https://t.me/zilaaaant" target="_blank">https://t.me/zilaaaant</a>',

  tulpar:
    "Привет! Тест показал — тебе точно по пути с Тулпаром \n" +
    "\n" +
    "Здесь ценят скорость, мудрость и искренность, но главное — мы действуем вместе и держим темп.\n" +
    "Тулпар — это энергия, решительность и настоящие моменты, которые остаются с тобой.\n" +
    "\n" +
    "Сделай шаг, потом полет!\n" +
    'Присоединяйся к нам: <a href="https://t.me/golittle2lpar" target="_blank">https://t.me/golittle2lpar</a>\n' +
    "\n" +
    "Сделаем этот Лига Форум незабываемым вместе?",

  samruh:
    "Привет! Тест показал, что ты рожден для того, чтобы стать участником самого яркого и громкого направления! \n" +
    "\n" +
    "Мы невероятно рады, видеть тебя в направлении Самрух! Самовыражайся, не бойся быть собой, и помни: чтобы прожить уникальную жизнь, нужно быть уникальным человеком \n" +
    "\n" +
    "Подписывайся на наш телеграм-канал, чтобы всегда быть в курсе последних новостей: \n" +
    '<a href="https://t.me/samrukh" target="_blank">https://t.me/samrukh</a> \n' +
    "\n" +
    "Давай вместе сделаем этот Лига Форум незабываемым!",
};
